<template>
  <div class="d-flex pointer icon">
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13 6L8 11L3 6" stroke="#252525" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    </svg>

  </div>
</template>
